const Layout = () => import ( /* webpackChunkName: "index" */ `@/page/layoutVersion/index.vue`);
const MobileLayout = () => import ( /* webpackChunkName: "index" */ `@/mobile/mobileLayout.vue`);
import subRouter from './subrouter';
import mobile from './mobile/index'
import demo from './demo/demo';
import wage from './wage/wage';
import homepage from './wage/homepage';
import tesla from './tesla/tesla';
import report from './report/report';
import dataInput from './dataInput/dataInputZL';
import hrCloud from './hrcloud/hrCloud';
import hrCloudSet from './hrcloud/hrCloudSet';
import financeService from './finance/service';
import anniversary from './anniversary/anniversary';
import v2Routes from './v2'
import policy from './policy'
import tesla1 from './tesla/teslaCustomRecord'
export const constantRoutes = [
  {
    path: '/',
    name: '主页',
    redirect: '/login',
  },
  {
    path: '/loginOldV2',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/index.vue`),
    meta: { version: 'v2' }
  },
  {
    path: '/login',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/login-v2/index.vue`),
    meta: { version: 'v2' }
  },
  {
    path: '/loginOld',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/index.vue`),
    meta: { version: '1' }
  },
  {
    path: '/emailConfirm',
    name: '邮件确认',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/emailConfirm.vue`),
    meta: { version: '1' }
  },
  {
    path: '/loginWeb',
    name: '官网登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/web-login/index.vue`),
    meta: { version: '2' }
  },
  {
    path: '/ciicWeb',
    name: '薪税官网',
    redirect: '/ciicWeb/home',
    component: () => import ( /* webpackChunkName: "ciicWeb" */ `@/page/ciicWeb/ciicWeb.vue`),
    children: [
      {
        path: 'home',
        name: '官网首页',
        component: () => import ( /* webpackChunkName: "home" */ `@/page/ciicWeb/webPage/home/home.vue`),
      },
      {
        path: 'product',
        name: '产品',
        component: () => import ( /* webpackChunkName: "home" */ `@/page/ciicWeb/webPage/product/product.vue`),
      },
      {
        path: 'customerService',
        name: '客服服务',
        component: () => import ( /* webpackChunkName: "home" */ `@/page/ciicWeb/webPage/customerService/customerService.vue`),
      },
      {
        path: 'latestNews',
        name: '最新资讯',
        component: () => import ( /* webpackChunkName: "home" */ `@/page/ciicWeb/webPage/latestNews/latestNews.vue`),
      },
      {
        path: 'aboutUs',
        name: '关于我们',
        component: () => import ( /* webpackChunkName: "home" */ `@/page/ciicWeb/webPage/aboutUs/aboutUs.vue`),
      },
    ]
  },
  {
    path: '/wxloginRedirect',
    name: '微信重定向',
    component: () => import ( /* webpackChunkName: "wxloginRedirect" */ `@/page/new-login/wxloginRedirect.vue`),
  },
  {
    path: '/register',
    name: '邀请注册',
    component: () => import ( /* webpackChunkName: "register" */ `@/page/register/index.vue`),
  },
  {
    path: '/lock',
    name: '锁屏',
    component: () => import ( /* webpackChunkName: "lock" */ `@/page/lock/index.vue`),
  },

  {
    path: '/404',
    component: () => import ( /* webpackChunkName: "404" */ `@/components/ciic/error-page/404.vue`),
    name: '404',
  },
  {
    path: '/403',
    component: () => import ( /* webpackChunkName: "403" */ `@/components/ciic/error-page/403.vue`),
    name: '403',
  },
  {
    path: '/500',
    component: () => import ( /* webpackChunkName: "500" */ `@/components/ciic/error-page/500.vue`),
    name: '500',
  },
  {
    path: '/biz/payroll',
    component: () => import ( /* webpackChunkName: "500" */ `@/page/salarySheet/salarySheetLogin.vue`),
    name: 'SalarySheetLogin',
  },
  {
    path: '/biz/salarySheetView',
    component: () => import ( /* webpackChunkName: "500" */ `@/page/salarySheet/salarySheetView.vue`),
    name: 'salarySheetView',
  },
  {
    path: '/policy/policyLibrary/industryReportView',
    name: 'IndustryReportView',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/industryReport/view.vue`),
    meta:{
      title: '行业报告详情'
    }
  },
  {
    path: '/cancelSubscribe',
    name: 'CancelSubscribe',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/policyExpress/subscribe.vue`),
    meta:{
      title: '取消订阅'
    }
  },
  {
    path: '/tesla/customRecord',
    name: 'TeslaCustomRecord',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/tesla/customRecord/index.vue`),
    meta:{
      title: '特斯拉记录数据'
    }
  },
  {
    path: '/t/:ttype/:tid',
    name: 'shortUrl',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/shorturl/shortUrl.vue`),
    meta:{
      title: '中智薪税云'
    }
  },
  {
    path: '/mobile',
    name: 'MobileLayout',
    component: MobileLayout,
    children: [
      ...mobile
    ]
  },
  {
    path: '/receipt/verification',
    name: 'ReceiptVerificationPlatform',
    component: () => import ( /* webpackChunkName: "receipt-verification" */ `@/views/verification-platform/index.vue`),
    meta: {
      title: '电子收据唯一核验平台'
    }
  }
]
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    children: [...wage, ...subRouter, ...demo, ...hrCloud, ...hrCloudSet, ...report, ...dataInput, ...homepage, ...tesla,...financeService,...anniversary, ...v2Routes, ...policy, ...tesla1]
  }
]
